import React, {useEffect} from 'react'
import {useNavigate} from 'react-router-dom-v5-compat'
import {setLogContext} from '@/logger'
import {Flex} from '../../utils/chakraMonomorphic'
import {ActionButton, CustomIcon} from '../../components'
import {useAuth} from '../../stores/AuthStore'

export const LogoutView: React.FC<React.PropsWithChildren> = () => {
  setLogContext('LogoutView')
  const navigate = useNavigate()
  const {logout, authenticationStatus} = useAuth()

  useEffect(() => {
    if (authenticationStatus === 'authenticated') {
      // Fire-and-forget; catch so a rejected logout (already logged inside
      // AuthStore.logout) doesn't surface as an unhandled rejection.
      logout().catch(() => {
        // already logged inside AuthStore.logout
      })
    }
  }, [authenticationStatus, logout])

  return (
    <Flex alignItems='center' flexDirection='column' height='100vh'>
      {/* copied from primary navigation component */}
      <Flex
        width={['100vw']}
        borderBottom='1px'
        borderTop={['0', '3px solid #E68C4D']}
        height={['40px', '64px']}
        bg='white'>
        <Flex width={['3%', '20%']} justifyContent='flex-start'>
          <CustomIcon
            name='phone'
            maxWidth='8rem'
            ml={2}
            boxSize='100%'
            display={['none', 'inline-block']}
          />
        </Flex>
      </Flex>
      {/* copied from page template component */}
      <Flex
        flex='1'
        direction='column'
        align='center'
        justify='center'
        width={['100vw']}>
        <ActionButton
          onClick={() => {
            navigate('/login', {replace: true})
          }}>
          Return to Login
        </ActionButton>
      </Flex>
    </Flex>
  )
}
